import { render, staticRenderFns } from "./NavItemSidebar.vue?vue&type=template&id=0978b595&scoped=true"
import script from "./NavItemSidebar.vue?vue&type=script&lang=js"
export * from "./NavItemSidebar.vue?vue&type=script&lang=js"
import style0 from "./NavItemSidebar.vue?vue&type=style&index=0&id=0978b595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978b595",
  null
  
)

export default component.exports